import TraceContainer from '@components/containers/trace';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const Trace: FC = () => (
    <AppLayout>
        <TraceContainer />
    </AppLayout>
);

export default Trace;
